interface OccurrenceWithRatesObject {
  occurrence?: {
    id: string;
    startUtc?: number | Date | null;
    endUtc?: number | Date | null;
    closed?: boolean | null | undefined;
  } | null;
  rates?:
    | {
        remainingTickets?: number | null;
      }[]
    | null;
}

export const generateMenuItemOccurrences = (occurrencesWithRates: OccurrenceWithRatesObject[]) =>
  occurrencesWithRates
    .filter((occurrencesWithRatesItem) => occurrencesWithRatesItem.occurrence !== null)
    .map((occurrencesWithRatesItem) => {
      return {
        occurrenceId: occurrencesWithRatesItem?.occurrence?.id,
        startUtc: occurrencesWithRatesItem?.occurrence?.startUtc,
        endUtc: occurrencesWithRatesItem?.occurrence?.endUtc,
        isClosed: occurrencesWithRatesItem?.occurrence?.closed,
        isDisabled: occurrencesWithRatesItem.rates?.every((rateItem) => {
          return (
            rateItem.remainingTickets !== undefined &&
            rateItem.remainingTickets !== null &&
            rateItem.remainingTickets <= 0
          );
        }),
      };
    });
